import styled from 'styled-components'

export const ArrowContainer = styled.div`
  transform: ${p => (p.isExpanded ? 'rotate(0deg)' : 'rotate(180deg)')};
  transition: transform ease-out 0.2s;
  cursor: pointer;
`
